import { Link } from 'react-router-dom'

const SERVERS = [
  { label: 'AX', color: '#00ffff', active: true },
  { label: 'GH', color: '#7f53ff' },
  { label: 'DV', color: '#00ff88' },
]

const CHANNELS = [
  { name: 'general', active: true },
  { name: 'announcements' },
  { name: 'off-topic' },
]

const MESSAGES = [
  { user: 'Anderson', avatar: 'A', color: '#00ffff', content: 'hey everyone, new build just dropped 🔥', time: '9:41 AM' },
  { user: 'Nova', avatar: 'N', color: '#7f53ff', content: 'finally — latency improvements are massive', time: '9:42 AM' },
  { user: 'Cipher_X', avatar: 'C', color: '#00ff88', content: 'sub-10ms on voice. no cap', time: '9:42 AM' },
  { user: 'Anderson', avatar: 'A', color: '#00ffff', content: 'E2E encryption is live too 🔐', time: '9:43 AM' },
  { user: 'Nova', avatar: 'N', color: '#7f53ff', content: 'done with Discord permanently', time: '9:44 AM' },
]

const MEMBERS = ['Anderson', 'Nova', 'Cipher_X']

const FEATURES = [
  { icon: '💬', title: 'Real-Time Messaging', desc: 'Instant delivery via Socket.IO. Edit, delete, react — full history with pagination.' },
  { icon: '🎙️', title: 'WebRTC Voice', desc: 'Low-latency peer-to-peer voice channels. No third-party relay — your calls stay private.' },
  { icon: '🏠', title: 'Servers & Channels', desc: 'Organize communities with servers, text channels, roles, and member permissions.' },
  { icon: '✉️', title: 'Direct Messages', desc: 'Private one-to-one conversations with the same real-time stack as server channels.' },
  { icon: '🔐', title: 'Verified Identities', desc: 'Domain-verified accounts so you always know who you\'re talking to.' },
  { icon: '🔌', title: 'Nexus SDK', desc: 'Embed AeThex Connect into any platform. Game launchers, web apps, dashboards.' },
]

function FakePanel() {
  return (
    <div style={{
      width: '100%',
      aspectRatio: '16/10',
      background: '#0d0d0d',
      border: '1px solid #1e1e1e',
      borderRadius: 10,
      overflow: 'hidden',
      boxShadow: '0 0 0 1px rgba(0,255,255,0.06), 0 32px 80px rgba(0,0,0,0.7), 0 0 60px rgba(127,83,255,0.1)',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'JetBrains Mono, monospace',
      position: 'relative',
    }}>
      {/* gradient rim */}
      <div style={{
        position: 'absolute', inset: -1, borderRadius: 11, pointerEvents: 'none', zIndex: 10,
        background: 'linear-gradient(135deg, rgba(0,255,255,0.12), transparent 40%, rgba(127,83,255,0.12))',
      }} />

      {/* title bar */}
      <div style={{
        height: 30, background: '#0d0d0d', borderBottom: '1px solid #1e1e1e',
        display: 'flex', alignItems: 'center', padding: '0 10px', gap: 6, flexShrink: 0,
      }}>
        <span style={{ width: 9, height: 9, borderRadius: '50%', background: '#ff5f57', display: 'block' }} />
        <span style={{ width: 9, height: 9, borderRadius: '50%', background: '#febc2e', display: 'block' }} />
        <span style={{ width: 9, height: 9, borderRadius: '50%', background: '#28c840', display: 'block' }} />
        <span style={{ margin: '0 auto', fontSize: 10, color: '#555', letterSpacing: '0.04em' }}>
          connect.aethex.online
        </span>
      </div>

      {/* app body */}
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>

        {/* server rail */}
        <div style={{
          width: 44, background: '#080808', borderRight: '1px solid #1a1a1a',
          display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '8px 0', gap: 6, flexShrink: 0,
        }}>
          {SERVERS.map(s => (
            <div key={s.label} style={{
              width: 28, height: 28, borderRadius: s.active ? 8 : 14,
              background: s.active ? s.color : '#1a1a1a',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 9, fontWeight: 700, color: s.active ? '#000' : s.color,
              border: s.active ? 'none' : `1px solid ${s.color}33`,
              flexShrink: 0, transition: 'border-radius 0.15s',
              boxShadow: s.active ? `0 0 10px ${s.color}55` : 'none',
            }}>{s.label}</div>
          ))}
          <div style={{
            width: 28, height: 28, borderRadius: 14, background: '#1a1a1a',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 14, color: '#00ffff', marginTop: 4,
          }}>+</div>
        </div>

        {/* channel sidebar */}
        <div style={{
          width: 110, background: '#0a0a0a', borderRight: '1px solid #1a1a1a',
          display: 'flex', flexDirection: 'column', flexShrink: 0,
        }}>
          <div style={{
            padding: '8px 8px 6px', borderBottom: '1px solid #1a1a1a',
            fontSize: 9, fontWeight: 700, color: '#fff', letterSpacing: '0.04em',
          }}>AeThex HQ</div>
          <div style={{ padding: '6px 6px 2px', fontSize: 8, color: '#555', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
            Text
          </div>
          {CHANNELS.map(ch => (
            <div key={ch.name} style={{
              padding: '3px 8px', fontSize: 9, color: ch.active ? '#00ffff' : '#666',
              background: ch.active ? 'rgba(0,255,255,0.06)' : 'transparent',
              borderRadius: 4, margin: '1px 4px',
              display: 'flex', alignItems: 'center', gap: 3,
            }}>
              <span style={{ color: '#555' }}>#</span> {ch.name}
            </div>
          ))}
          <div style={{ padding: '6px 6px 2px', fontSize: 8, color: '#555', letterSpacing: '0.1em', textTransform: 'uppercase', marginTop: 4 }}>
            Voice
          </div>
          {['lounge', 'dev-chat'].map(ch => (
            <div key={ch} style={{
              padding: '3px 8px', fontSize: 9, color: '#555',
              display: 'flex', alignItems: 'center', gap: 3,
            }}>
              <span>🔊</span> {ch}
            </div>
          ))}
        </div>

        {/* chat area */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', background: '#0d0d0d' }}>
          {/* channel header */}
          <div style={{
            height: 32, borderBottom: '1px solid #1a1a1a', display: 'flex', alignItems: 'center',
            padding: '0 10px', gap: 5, flexShrink: 0,
          }}>
            <span style={{ color: '#555', fontSize: 11 }}>#</span>
            <span style={{ fontSize: 9, color: '#ccc', fontWeight: 700 }}>general</span>
            <span style={{ fontSize: 8, color: '#444', marginLeft: 4 }}>AeThex HQ public channel</span>
          </div>

          {/* messages */}
          <div style={{ flex: 1, padding: '8px 10px', display: 'flex', flexDirection: 'column', gap: 7, overflow: 'hidden' }}>
            {MESSAGES.map((m, i) => (
              <div key={i} style={{ display: 'flex', gap: 6, alignItems: 'flex-start' }}>
                <div style={{
                  width: 20, height: 20, borderRadius: 4, background: m.color + '22',
                  border: `1px solid ${m.color}55`, display: 'flex', alignItems: 'center',
                  justifyContent: 'center', fontSize: 8, fontWeight: 700, color: m.color, flexShrink: 0,
                }}>{m.avatar}</div>
                <div>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 5 }}>
                    <span style={{ fontSize: 8, fontWeight: 700, color: m.color }}>{m.user}</span>
                    <span style={{ fontSize: 7, color: '#444' }}>{m.time}</span>
                  </div>
                  <div style={{ fontSize: 8, color: '#aaa', marginTop: 1, lineHeight: 1.4 }}>{m.content}</div>
                </div>
              </div>
            ))}
          </div>

          {/* input */}
          <div style={{
            margin: '0 10px 8px', padding: '5px 8px',
            background: '#161616', border: '1px solid #2a2a2a', borderRadius: 4,
            display: 'flex', alignItems: 'center', gap: 6,
          }}>
            <span style={{ fontSize: 8, color: '#444', flex: 1 }}>Message #general…</span>
            <span style={{ fontSize: 10, color: '#333' }}>↵</span>
          </div>
        </div>

        {/* member list */}
        <div style={{
          width: 80, background: '#0a0a0a', borderLeft: '1px solid #1a1a1a',
          padding: '8px 6px', flexShrink: 0,
        }}>
          <div style={{ fontSize: 7, color: '#555', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 6 }}>
            Online — 3
          </div>
          {MEMBERS.map(name => (
            <div key={name} style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: 5 }}>
              <div style={{
                width: 6, height: 6, borderRadius: '50%', background: '#00ff88', flexShrink: 0,
              }} />
              <span style={{ fontSize: 7, color: '#888', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default function LandingPage() {
  return (
    <div style={{ fontFamily: 'JetBrains Mono, monospace', background: '#050505', color: '#d4d4d4', minHeight: '100vh', overflowX: 'hidden' }}>

      {/* scanline overlay */}
      <div style={{
        position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 9999,
        background: 'repeating-linear-gradient(0deg, rgba(0,0,0,0.1) 0px, rgba(0,0,0,0.1) 1px, transparent 1px, transparent 2px)',
      }} />

      {/* NAV */}
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 2.5rem', height: 60,
        background: 'rgba(5,5,5,0.85)', backdropFilter: 'blur(12px)',
        borderBottom: '1px solid #1e1e1e',
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
          <span style={{ fontSize: 15, fontWeight: 700, color: '#fff', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
            AeThex
          </span>
          <span style={{ fontSize: 11, color: '#555', letterSpacing: '0.06em' }}>Connect</span>
        </Link>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <Link to="/login" style={{
            fontFamily: 'JetBrains Mono, monospace', fontSize: 11, color: '#666',
            background: 'none', border: '1px solid #1e1e1e', borderRadius: 5,
            padding: '6px 14px', textDecoration: 'none', letterSpacing: '0.05em',
            transition: 'color 0.15s, border-color 0.15s',
          }}
          onMouseEnter={e => { (e.target as HTMLElement).style.color = '#00ffff'; (e.target as HTMLElement).style.borderColor = '#00ffff' }}
          onMouseLeave={e => { (e.target as HTMLElement).style.color = '#666'; (e.target as HTMLElement).style.borderColor = '#1e1e1e' }}
          >
            Sign In
          </Link>
          <Link to="/app" style={{
            fontFamily: 'JetBrains Mono, monospace', fontSize: 11, fontWeight: 700,
            color: '#000', background: '#00ffff', border: 'none', borderRadius: 5,
            padding: '6px 14px', textDecoration: 'none', letterSpacing: '0.05em',
          }}>
            Launch App
          </Link>
        </div>
      </nav>

      {/* HERO */}
      <section style={{
        minHeight: '100vh', display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        alignItems: 'center', gap: '4rem',
        padding: '100px 6vw 4rem',
        position: 'relative', overflow: 'hidden',
      }}>
        {/* bg glow */}
        <div style={{
          position: 'absolute', top: '-20%', right: '-10%',
          width: '70vw', height: '70vw', pointerEvents: 'none',
          background: 'radial-gradient(circle, rgba(127,83,255,0.06) 0%, transparent 65%)',
        }} />

        {/* LEFT */}
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            fontSize: 11, fontWeight: 500, letterSpacing: '0.15em', textTransform: 'uppercase',
            color: '#00ffff', border: '1px solid rgba(0,255,255,0.2)',
            borderRadius: 4, padding: '5px 12px', marginBottom: 28,
          }}>
            <span style={{
              width: 6, height: 6, borderRadius: '50%', background: '#00ffff', display: 'block',
              animation: 'atx-pulse 2s ease-in-out infinite',
            }} />
            Now Live
          </div>

          <h1 style={{
            fontSize: 'clamp(2.2rem, 4vw, 3.6rem)', fontWeight: 700,
            lineHeight: 1.08, letterSpacing: '-0.02em', color: '#fff', marginBottom: 20,
          }}>
            Voice &amp; chat<br />
            <span style={{
              background: 'linear-gradient(90deg, #00ffff, #7f53ff)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}>built different.</span>
          </h1>

          <p style={{ fontSize: 14, lineHeight: 1.7, color: '#737373', maxWidth: 420, marginBottom: 36 }}>
            AeThex Connect is a next-generation communication platform for gaming communities.
            Servers, channels, real-time voice — all running on infrastructure you control.
          </p>

          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <Link to="/app" style={{
              fontFamily: 'JetBrains Mono, monospace', fontSize: 13, fontWeight: 700,
              color: '#000', background: 'linear-gradient(90deg, #00ffff, #7f53ff)',
              border: 'none', borderRadius: 6, padding: '11px 26px',
              textDecoration: 'none', letterSpacing: '0.06em', textTransform: 'uppercase',
            }}>
              Open Platform
            </Link>
            <Link to="/signup" style={{
              fontFamily: 'JetBrains Mono, monospace', fontSize: 13, fontWeight: 500,
              color: '#d4d4d4', background: 'none', border: '1px solid #1e1e1e',
              borderRadius: 6, padding: '11px 26px', textDecoration: 'none',
              letterSpacing: '0.06em', textTransform: 'uppercase',
            }}>
              Create Account
            </Link>
          </div>

          <div style={{
            display: 'flex', gap: 36, marginTop: 40, paddingTop: 28,
            borderTop: '1px solid #1e1e1e',
          }}>
            {[['WebRTC', 'Voice & Video'], ['E2E', 'Encrypted'], ['Open', 'Source']].map(([val, label]) => (
              <div key={val}>
                <div style={{ fontSize: 20, fontWeight: 700, color: '#fff' }}>{val}</div>
                <div style={{ fontSize: 10, color: '#555', letterSpacing: '0.08em', textTransform: 'uppercase', marginTop: 3 }}>{label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT — fake panel */}
        <div style={{ position: 'relative', zIndex: 1 }}>
          <FakePanel />
        </div>
      </section>

      {/* FEATURES */}
      <section style={{ padding: '6rem 6vw', borderTop: '1px solid #1e1e1e' }}>
        <div style={{ fontSize: 11, fontWeight: 500, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#00ffff', marginBottom: 12 }}>
          Platform
        </div>
        <h2 style={{ fontSize: 'clamp(1.5rem, 2.8vw, 2rem)', fontWeight: 700, color: '#fff', marginBottom: 48, maxWidth: 480 }}>
          Everything your community needs.
        </h2>
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 1, background: '#1e1e1e', border: '1px solid #1e1e1e', borderRadius: 8, overflow: 'hidden',
        }}>
          {FEATURES.map(f => (
            <div key={f.title} style={{ background: '#111', padding: '28px 24px' }}
              onMouseEnter={e => ((e.currentTarget as HTMLElement).style.background = '#161616')}
              onMouseLeave={e => ((e.currentTarget as HTMLElement).style.background = '#111')}
            >
              <span style={{ fontSize: 22, display: 'block', marginBottom: 14 }}>{f.icon}</span>
              <h3 style={{ fontSize: 13, fontWeight: 700, color: '#fff', marginBottom: 8, letterSpacing: '0.03em' }}>{f.title}</h3>
              <p style={{ fontSize: 12, lineHeight: 1.6, color: '#555' }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA BAND */}
      <div style={{
        margin: '0 6vw 6rem', padding: '3rem 2.5rem',
        background: '#111', border: '1px solid #1e1e1e', borderRadius: 10,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: '2rem', flexWrap: 'wrap', position: 'relative', overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', inset: 0, pointerEvents: 'none',
          background: 'linear-gradient(90deg, rgba(0,255,255,0.03), rgba(127,83,255,0.03))',
        }} />
        <div style={{ position: 'relative' }}>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: '#fff', marginBottom: 6 }}>Ready to connect?</h2>
          <p style={{ fontSize: 13, color: '#555' }}>Free to use. No tracking. No ads. Just communication.</p>
        </div>
        <Link to="/app" style={{
          fontFamily: 'JetBrains Mono, monospace', fontSize: 13, fontWeight: 700,
          color: '#000', background: 'linear-gradient(90deg, #00ffff, #7f53ff)',
          border: 'none', borderRadius: 6, padding: '11px 26px',
          textDecoration: 'none', letterSpacing: '0.06em', textTransform: 'uppercase',
          position: 'relative', whiteSpace: 'nowrap',
        }}>
          Launch AeThex Connect
        </Link>
      </div>

      {/* FOOTER */}
      <footer style={{
        borderTop: '1px solid #1e1e1e', padding: '1.75rem 6vw',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexWrap: 'wrap', gap: '1rem',
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
          <span style={{ fontSize: 12, color: '#555', letterSpacing: '0.06em' }}>
            AeThex Connect &nbsp;·&nbsp; © 2026 AeThex Corporation
          </span>
        </Link>
        <nav style={{ display: 'flex', gap: 24 }}>
          {[['Privacy', '/privacy'], ['Terms', '/terms'], ['Sign In', '/login']].map(([label, href]) => (
            <Link key={label} to={href} style={{ fontSize: 12, color: '#555', textDecoration: 'none' }}
              onMouseEnter={e => ((e.target as HTMLElement).style.color = '#00ffff')}
              onMouseLeave={e => ((e.target as HTMLElement).style.color = '#555')}
            >{label}</Link>
          ))}
        </nav>
      </footer>

      <style>{`
        @keyframes atx-pulse {
          0%, 100% { opacity: 1; box-shadow: 0 0 0 0 rgba(0,255,255,0.4); }
          50% { opacity: 0.7; box-shadow: 0 0 0 5px rgba(0,255,255,0); }
        }
        @media (max-width: 860px) {
          section[style*="grid-template-columns"] {
            grid-template-columns: 1fr !important;
          }
          section[style*="grid-template-columns"] > div:last-child {
            display: none;
          }
        }
      `}</style>
    </div>
  )
}
